import { ValueType } from 'react-select';

import {
  SET_IMAGE_PAIR,
  SET_TIMELINE_OPEN,
  SET_CURRENT_SELECTED_IMAGE,
  CLEAR_CURRENT_SELECTED_IMAGE,
  CLEAR_CURRENT_IMAGE_PAIR,
  SET_TIME_BEING_SELECTED,
  SET_AUDIT_AREA,
  SET_CONTEXTUAL_AREA,
  REMOVE_IMAGE_PAIR,
  CLEAR_IMAGE_PAIRS,
  SET_CREATING_RIVER_BOUNDARIES,
  SET_BUFFER_DISTANCE,
  SET_BUFFER_UNIT,
  SET_MERGE_INTERSECT_LAYERS,
  SET_MERGE_INTERSECT_OPERATION
} from '../../constants/appTypes';

import { IOptionsType } from '../../types/react-select-options';
import { IImagePair, ITimelineImageObject } from '../../types/timeline';

export function setImagePair(imagePair: IImagePair) {
  return {
    type: SET_IMAGE_PAIR,
    imagePair,
  };
}

export function removeImagePair(imagePair: IImagePair) {
  return {
    type: REMOVE_IMAGE_PAIR,
    imagePair
  };
}

export function clearImagePairs() {
  return {
    type: CLEAR_IMAGE_PAIRS
  };
}

export function setTimelineOpen(open: boolean) {
  return {
    type: SET_TIMELINE_OPEN,
    open,
  };
}

export function setCurrentSelectedImage(image: ITimelineImageObject, isBefore: boolean) {
  return {
    type: SET_CURRENT_SELECTED_IMAGE,
    image,
    isBefore: isBefore,
  };
}

export function clearCurrentSelectedImage(isBefore: boolean) {
  return {
    type: CLEAR_CURRENT_SELECTED_IMAGE,
    isBefore: isBefore,
  };
}

export function clearCurrentImagePair() {
  return {
    type: CLEAR_CURRENT_IMAGE_PAIR
  }
}

export function setTimeBeingSelected(isBefore: boolean) {
  return {
    type: SET_TIME_BEING_SELECTED,
    isBefore,
  };
}

export function setAuditArea(graphic: __esri.Graphic | null, size: number, treeLoss: Array<number>) {
  return {
    type: SET_AUDIT_AREA,
    graphic,
    size,
    treeLoss
  };
}

export function setContextualArea(graphic: __esri.Graphic | null) {
  return {
    type: SET_CONTEXTUAL_AREA,
    graphic,
  };
}

export function setCreatingRiverBoundaries(creating: boolean) {
  return {
    type: SET_CREATING_RIVER_BOUNDARIES,
    creating,
  };
}

export const setBufferDistance = (distance: number) => {
  return {
    type: SET_BUFFER_DISTANCE,
    distance,
  };
};

export const setBufferUnit = (unit: 'feet' | 'meters') => {
  return {
    type: SET_BUFFER_UNIT,
    unit,
  };
};

export const setSelectedMergeIntersectLayers = (selectedLayers: ValueType<IOptionsType>) => {
  return {
    type: SET_MERGE_INTERSECT_LAYERS,
    selectedLayers,
  };
};

export const setSelectedMergeIntersectOperation = (selectedOperation: string) => {
  return {
    type: SET_MERGE_INTERSECT_OPERATION,
    selectedOperation,
  };
};
